export default {
    name: 'blockBuilder',
    component(settings, colorSchema = '', type = '') {
      return {
        isVisible: !settings.hover_controlled || settings.default_visible,
        targetMenuItems: settings.target_menu_handles ? settings.target_menu_handles.split(',').map(item => item.trim()) : [],
        hasSticky: settings.always_show_bg || false,
        classes: '',
        isLatchSource: settings.is_latch_source || false,
        isLatchTarget: settings.is_latch_target || false,
        latchedContentVisible: false,
        
        init() {
          // Set up a global event listener for the menu hover events
          window.addEventListener('menu-hover:enter', (event) => this.handleMenuHover(event));
          
          if (settings.hover_controlled && settings.auto_show_duration > 0) {
            setTimeout(() => {
              this.isVisible = true;
            }, settings.auto_show_duration * 1000);
          }
          
          // Calculate responsive classes
          this.classes = this.getResponsiveClasses(settings);
          
          // Add scroll event listener
          if (settings.apply_bg_on_scroll) {
            const scrollThreshold = settings.scroll_threshold || 50;
            window.addEventListener('scroll', () => {
              const scrollY = window.scrollY;
              if (scrollY >= scrollThreshold) {
                this.hasSticky = true;
                console.log('Background color applied');
              } else {
                this.hasSticky = settings.always_show_bg || false;
                console.log('Background color not applied');
              }
            });
            
            // Check initial scroll position
            if (window.scrollY >= (settings.scroll_threshold || 50)) {
              this.hasSticky = true;
              console.log('Background color applied');
            }
          }

          // Listen for latching events if this is a target
          if (this.isLatchTarget) {
            // Start hidden if this is a latch target
            // this.$el.classList.add('hidden');
            
            // Listen for latching events
            document.addEventListener('content-latched', (event) => {
              if (event.detail.stickyBlockId === settings.custom_id) {
                this.latchedContentVisible = true;
              }
            });

            document.addEventListener('content-unlatched', (event) => {
              if (event.detail.stickyBlockId === settings.custom_id) {
                this.latchedContentVisible = false;
              }
            });
          }

          // Add latch class if this is a source
          if (this.isLatchSource) {
            // Add class to mark the content that should be latched
            const blockContent = this.$el.querySelector('.block-builder-container');
            if (blockContent) {
              blockContent.classList.add('block-content-to-latch');
            }
          }
        },
        
        getResponsiveClasses(settings) {
          // Add your existing class calculations here if needed
          return '';
        },
        
        handleMenuHover(event) {
          // console.log('Menu hover event received:', event.detail);
          if (!settings.hover_controlled) return;
          
          const linkId = event.detail.linkId;
          const linkTitle = event.detail.linkTitle;
          
          // Check if this section responds to this menu item
          if (
            (this.targetMenuItems.includes(linkId) || this.targetMenuItems.includes(linkTitle)) ||
            (settings.target_menu_id && settings.target_menu_id === linkId) || 
            (settings.target_menu_title && settings.target_menu_title === linkTitle)
          ) {
            // console.log('Showing section based on menu hover:', linkId, linkTitle);
            this.isVisible = true;
          } else {
            // console.log('Hiding section based on menu hover:', linkId, linkTitle);
            this.isVisible = false;
          }
        },
        
        handleBlockLeave() {
          // Only hide the block when the mouse leaves the block itself
          if (!settings.hover_controlled) return;
          
          // Only hide if we shouldn't stay visible
          if (!settings.stay_visible_after_hover) {
            // console.log('Hiding section because mouse left the block builder');
            this.isVisible = false;
          }
        }
      }
    }
  };
